import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewMatchPageNew from "../../components/MatchDiscoveryControl/ViewMatchPageNew";

const ViewMatchPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb
          id="title"
          title2="Match Users"
          link2="/match-control"
          title="View Match "
        />
        <ViewMatchPageNew />
      </MasterLayout>
    </>
  );
};

export default ViewMatchPage;
